import React from "react";
import { Input } from "antd";
import styles from "./CustomInput.module.css";

const CustomInput = ({ 
  type = "text", 
  placeholder, 
  value, 
  onChange, 
  onBlur,
  prefix,
  suffix,
  size = "large",
  className = "",
  ...props 
}) => {
  const inputClass = `${styles.customInput} ${className}`;

  // Handle hidden input type
  if (type === "hidden") {
    return (
      <input
        type="hidden"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        {...props}
      />
    );
  }

  if (type === "password") {
    return (
      <Input.Password
        className={inputClass}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        prefix={prefix}
        suffix={suffix}
        size={size}
        {...props}
      />
    );
  }

  return (
    <Input
      className={inputClass}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      prefix={prefix}
      suffix={suffix}
      size={size}
      {...props}
    />
  );
};

export default CustomInput;
